var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex"},[_c('div',{staticClass:"pa-4 white"},[_c('v-img',{attrs:{"aspect-ratio":1,"src":'https://api.qrserver.com/v1/create-qr-code/?size=260x260&data='+_vm.data,"width":_vm.size}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }